export default __webpack_public_path__ + "static/media/pic6.51bfd149.jpg";